import HttpClient from 'httpClient';

export function getPopularHotels() {
  return HttpClient.get(`/wp-json/tripx/v1/popular-hotels`);
}
